export default {
  // Hero
  hero_title: "CATÁLOGO DE EQUIPAMENTOS PARA CONSTRUÇÃO VERTICAL",
  hero_view_products: "Ver Produtos",
  hero_request_quote: "Solicitar Orçamento",

  // Products Section
  products_title: "Equipamentos de Alta Performance",
  product1_name: "Elevador de Obra Cremalheira",
  product2_name: "Grua de Escalada com Sistema de Elevação",

  // Specifications
  spec_work_height: "Altura de Trabalho",
  spec_load_capacity: "Capacidade de Carga",
  spec_speed: "Velocidade",
  spec_configuration: "Configuração",
  spec_total_area: "Área Interna Total",
  spec_floor_area: "Área do Piso",
  spec_volume: "Volume Aproximado",
  spec_tower_height: "Altura da Torre",
  spec_service_height: "Altura de Atendimento",
  spec_max_capacity: "Capacidade Máxima",
  spec_steel_cables: "Cabos de Aço",

  // Product Details
  product1_safety_title: "Recursos de Segurança",
  product1_safety_desc: "Sistema sem cancela",
  product2_accessories_title: "Acessórios Inclusos",
  product2_accessories_desc: "Garfo para carga até 2.000 kg + Balde para concreto",

  // Video Section
  video_title: "Veja os Equipamentos em Operação",

  // Conditions
  conditions_delivery_title: 'Condições de Entrega e Pagamento',
  conditions_delivery_subtitle: 'Informações sobre prazos e logística',
  conditions_shipping_title: 'Previsão de Embarque',
  conditions_shipping_desc: '30 dias após confirmação do pedido',
  conditions_delivery_card_title: 'Entrega',
  conditions_delivery_desc: '60 dias após embarque (porto de destino)',
  conditions_packaging_title: 'Embalagem',
  conditions_packaging_desc: 'Wooden Case (caixa de madeira)',
  conditions_warranty_title: 'Garantia',
  conditions_warranty_period: '1 ano fornecida pelo fabricante',
  conditions_manufacturer_title: 'Fabricante',

  // Contact
  contact_title: "Entre em Contato",
  contact_schedule_title: "Agendar uma Reunião",
  contact_schedule_desc: "Converse com nossa equipe pelo Microsoft Teams",
  contact_email_title: "Fale Conosco",
  contact_email_desc: "Envie um e-mail para nossa equipe comercial",

  // Footer
  footer_description: "Equipamentos importados para construção vertical",
  footer_products: "Produtos",
  footer_product1: "Elevador de Obra",
  footer_product2: "Grua de Escalada",
  footer_info: "Informações",
  footer_about: "Sobre Nós",
  footer_warranty: "Garantia",
  footer_delivery: "Entrega",
  footer_contact: "Contato",
  footer_address: "R. Voluntários da Pátria, nº 2468 / 2490, 6º andar",
  footer_building: "Edifício Brasília Corporate",
  footer_hours: "Segunda a sexta-feira, 08:30 às 18:00 (GMT -03:00)",
  footer_rights: "© 2026 Moviis. Todos os direitos reservados.",

  // Language Switcher
  language_select: "Selecione o idioma",

  share: {
    whatsappMessage: 'Olá! Segue o catálogo de equipamentos para construção vertical Moviis:',
    emailSubject: 'Catálogo Moviis — Equipamentos para Construção Vertical',
    emailBody: 'Olá! Segue o catálogo de equipamentos para construção vertical Moviis:',
    whatsappTooltip: 'Compartilhar no WhatsApp',
    emailTooltip: 'Compartilhar por Email',
  },

  // Financial Summary
  financial_title: 'Resumo Financeiro',
  financial_subtitle: 'Valores e condições de pagamento',
  financial_total_label: 'Total do Pedido',
  financial_total_value: 'Sob consulta',
  financial_installment1_label: 'Parcela 1',
  financial_installment1_desc: '30% para iniciar produção',
  financial_installment1_value: 'Sob consulta',
  financial_installment2_label: 'Parcela 2',
  financial_installment2_desc: 'Pagamento do produto para liberação de embarque',
  financial_installment2_value: 'Sob consulta',
  financial_installment3_label: 'Parcela 3 (Saldo)',
  financial_installment3_desc: 'Chegada ao destino (porto ou aeroporto)',
  financial_installment3_value: 'Sob consulta',
  financial_invoice_date: 'Data: 4 de fevereiro de 2026',
  financial_considerations_title: 'Consideração da Proposta',
  financial_considerations_subtitle: 'Termos e condições importantes',
  financial_validity_label: 'Validade da proposta:',
  financial_validity: '15 dias',
  financial_shipping_label: 'Prazo de envio:',
  financial_shipping: 'Equipamentos devem ser enviados dentro de 3 meses. Após este prazo, o contrato será considerado inválido.',
  financial_observation_label: 'Observação:',
  financial_observation: 'Por se tratar de importação direta, qualquer substituição ou inclusão de novos itens implicará na necessidade de recálculo dos valores.',
  financial_assembly_label: 'Montagem e manutenção técnica:',
  financial_assembly: 'Não inclusas (responsabilidade do comprador).',
  financial_btn_print: 'Imprimir',
  financial_btn_pdf: 'Baixar em PDF',
  financial_btn_whatsapp: 'Enviar por WhatsApp',
  financial_btn_email: 'Enviar por E-mail',
};